import { createWebSocketStore } from 'src/components/#services/helpers';
export const withdraw = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'attempt_tryNew',
        agent: 'withdraw',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const withdrawTransactions = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'approval_getAllMyTransactions',
        agent: 'withdraw',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const confirmWithdraw = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'attempt_confirmWithdraw',
        agent: 'withdraw',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const cancelWithdraw = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'attempt_cancelAttempt',
        agent: 'withdraw',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
export const resendWithdrawConfirmation = createWebSocketStore({
    auth: true,
    requestTemplate: {
        method: 'attempt_resendConfirmation',
        agent: 'withdraw',
        lang: 'en',
        auth: { type: 'webSite' },
    },
});
